<template>
  <layout>
    <page-header :actions="actions" :header="$t('companies.edit_company')" />
    <div class="content">
      <resource-form
        v-if="currentDivision"
        :id="$route.params.id"
        :show-cancel-button="true"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import { create } from 'vue-modal-dialogs'
import ResourceForm from './Form.vue'
import CompanyMessage from './CompanyMessage'
import CommissionsApi from './CommissionsApi'

const resourceBase = 'companies'

export default {
  name: 'CompanyEdit',

  components: {
    ResourceForm,
  },

  computed: {
    actions() {
      return [
        {
          id: 'commissions',
          text: this.$t('company.process_commissions'),
          icon: 'icon-percent',
          onClick: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({
              name: `${resourceBase}.commissions`,
            })
          },
        },
        {
          id: 'message',
          text: this.$t('companies.message'),
          icon: 'icon-envelop2',
          onClick: () => {
            this.messageDialog(this.$route.params.id)
          },
        },
      ]
    },
  },

  created() {
    this.messageDialog = create(CompanyMessage, 'companyId')
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
    async generateInvoice() {
      const { value } = await this.$alert.question(
        this.$t('company.commissions.request_now_confirm'),
        '',
        {
          showCancelButton: true,
        },
      )

      if (value) {
        new CommissionsApi()
          .process([], this.$route.params.id)
          .then(result => {
            this.$toast.success(result.message)
          })
          .catch(response => {
            this.$toast.error(response.data.message)
          })
      }
    },
  },
}
</script>
